﻿var React = require('react');
var { createRoot } = require('react-dom/client');
var CoachSearchComponent = require('./CoachSearchComponent');

if (!window.location.origin) {
	window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
}

var root = createRoot(document.getElementById('coach-search'));
root.render(
	<CoachSearchComponent url="/coaches/api/search" />
);
